import axiosV1 from "@/plugins/axios/configV1";

export default {
    getProductRepairs(params) {
        return axiosV1.get(`product-repair`, { params });
    },
    getProductRepair(id = null) {
        return axiosV1.get(`product-repair/view/${id}`);
    },
    exportExcel(params) {
        return axiosV1.get(`product-repair/export`, { params });
    },
    importRepair(file = null) {
        let formData = new FormData();
        formData.append("file", file);
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`product-repair/import`, formData);
    },
};
